import * as THREE from "three";
import React, { useEffect, memo } from "react";
import Control from '../store/control';
import { Point } from "../shape/Point";
import { TextObject } from "../shape/Text";
import { ThreeDRotation } from "@material-ui/icons";


//-----------------------------------------
// 1点（＝クリック可能）を表示するマーカ
//-----------------------------------------
// vpoint: (Vector3)
// isActive: クリック可能か否か
// callback: クリック時のコールバック
const MPointFix = memo(({ text, vpoint, color, degree, isActive, callback }) => {
  const click        = Control.Get("click");
  const setControl   = Control.Get("setControl");
  const origin     = Control.Get('origin');
  var vpointText = [];

  useEffect(() => {
    if(click && isActive){
      callback(click);
      setControl(s => {s.click = null});
    }
  }, [click]);


  if (text == "In" || text == "Out") {
    if (vpoint != null) {
      //vpoint = new THREE.Vector3(vpoint.x, origin.y, vpoint.z);
      vpoint = new THREE.Vector3(vpoint.x, vpoint.y, vpoint.z);
      vpointText = new THREE.Vector3(vpoint.x, origin.y-10, vpoint.z);
    }
  } else if (text == "Tubercle" || text == "Condylar" || text == "End" || text == "Head" || text == "Greater trochanter") {
    if (vpoint != null) {
      vpoint = new THREE.Vector3(vpoint.x, vpoint.y, vpoint.z);
      vpointText = new THREE.Vector3(vpoint.x, vpoint.y-10, vpoint.z);
    }
  } else {
    vpointText = vpoint;
  }

  return (
    <>
      { vpoint ?
        <>
          <Point vpoint={vpoint} color={color} size={3}/>
          <TextObject text={text} vpoint={vpointText} color={color}/>
        </>
        : null }
    </>
  );
});

export default MPointFix;

/*import React, { useRef, useEffect, memo } from "react";
import { useThree } from "@react-three/fiber";
import Control from '../store/control';
import { Point } from "../shape/Point";


const MarkerPointFixed = memo(({ no, vpoint, color, isActive, SetPoint }) => {
  const { viewport } = useThree();
  const ref          = useRef();
  const click        = Control.Get("click");
  const SetControl   = Control.Get("SetControl");

  useEffect(() => {
    if(vpoint != null && ref.current){
      ref.current.position.x = vpoint.x;
      ref.current.position.y = vpoint.y;
      ref.current.position.z = vpoint.z;
    }
  }, [vpoint]);

  useEffect(() => {
    if(click && isActive){
      SetPoint(no, click);
      SetControl(s => {s.click = null});
    }
  }, [click, viewport]);

  return (
    <>
      { vpoint ?
        <Point ref={ref} color={color} size={1} />
        : null }
    </>
  );
});

export default MarkerPointFixed;
*/
